import type { SettingValueSemantics } from "./types";

const inputKindSearchText: Record<
  NonNullable<SettingValueSemantics["inputKind"]>,
  string
> = {
  color: "color colors colour colours hex brand branding theme appearance",
  email: "email address reply sender recipient",
  textarea: "copy message body long text multiline",
  timezone: "timezone time zone hours schedule availability locale",
  url: "url link website image logo webhook destination",
};

export function createValueSemanticsSearchText(
  valueSemantics: SettingValueSemantics | undefined,
): string | undefined {
  if (!valueSemantics) {
    return undefined;
  }

  const defaultValueText = getDefaultValueSearchText(
    valueSemantics.defaultValue,
  );
  const parts = [
    JSON.stringify(valueSemantics),
    valueSemantics.inputKind,
    valueSemantics.inputKind
      ? inputKindSearchText[valueSemantics.inputKind]
      : undefined,
    valueSemantics.unit,
    defaultValueText,
    valueSemantics.selectionMode === "multiple"
      ? "multiple multi select checklist choices"
      : undefined,
    valueSemantics.options?.length
      ? "option options select dropdown choices"
      : undefined,
    valueSemantics.trueLabel,
    valueSemantics.falseLabel,
    valueSemantics.unsetLabel,
    ...(valueSemantics.options ?? []).flatMap((option) => [
      option.value,
      option.label,
      option.description,
    ]),
  ];

  return parts.filter(isSearchTextPart).join(" ");
}

function isSearchTextPart(value: string | undefined): value is string {
  return typeof value === "string" && value.length > 0;
}

function getDefaultValueSearchText(
  defaultValue: SettingValueSemantics["defaultValue"] | undefined,
): string | undefined {
  return defaultValue == null ? undefined : String(defaultValue);
}
